const cExploreButton = function () {
    let cExploreButtonElement,
        cExploreContainer,
        cExploreButtonArrowElement,
        cExploreButtonDropdownElement,
        cExploreButtonSelectedTab,
        cExploreButtonSection,
        cExploreButtonTabs,
        cExploreButtonMenuRight;

    const reset = function () {
        cExploreButtonSection.hide(); // Hide all initially
        cExploreButtonTabs.find(".c-tabs-item").removeClass("c-tabs-item-active");
        cExploreButtonTabs.find(`.c-tabs-item[data-tab-item-key='${cExploreButtonSelectedTab}']`).addClass("c-tabs-item-active");

        let selectedSection = cExploreButtonSection.filter(`[data-tab-id='${cExploreButtonSelectedTab}']`);
        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]").hide();
        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]:eq(0)").show();
        selectedSection.find(".c-explore-section-menu-left li").removeClass("c-menu-left-item-active");
        selectedSection.find(".c-explore-section-menu-left li:eq(0)").addClass("c-menu-left-item-active");

        selectedSection.show(); // Show the selected one
    };

    const handleTabHover = function () {
        $(this).siblings().removeClass("c-tabs-item-active");
        $(this).addClass("c-tabs-item-active");

        cExploreButtonSelectedTab = $(this).data("tab-item-key");

        cExploreButtonSection.hide(); // Hide all initially
        let selectedSection = cExploreButtonSection.filter(`[data-tab-id='${cExploreButtonSelectedTab}']`);
        selectedSection.show(); // Show the selected one

        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]").hide();
        selectedSection.find(".c-explore-section-menu-right div[data-left-menu]:eq(0)").css("display", "flex");
        selectedSection.find(".c-explore-section-menu-left li").removeClass("c-menu-left-item-active");
        selectedSection.find(".c-explore-section-menu-left li:eq(0)").addClass("c-menu-left-item-active");

        selectedSection.find(".c-explore-section-menu-left li").hover(function () {
            const currentHover = $(this).data("id");
            $(this).siblings().removeClass("c-menu-left-item-active");
            $(this).addClass("c-menu-left-item-active");

            cExploreButtonMenuRight.find("div[data-left-menu]").hide();
            cExploreButtonMenuRight.find(`div[data-left-menu='${currentHover}']`).show();
        });
    };

    return {
        init: function (obj) {
            if (!obj) return;

            cExploreButtonElement = obj;
            cExploreButtonArrowElement = $(cExploreButtonElement).find("i");
            cExploreContainer = $(cExploreButtonElement).find("i");
            cExploreButtonDropdownElement = $(cExploreButtonElement).find(".c-explore-menu");
            cExploreButtonSelectedTab = $(cExploreButtonElement).find(".c-tabs-item-active").data("tab-item-key")
                || $(cExploreButtonElement).find(".c-tabs-item").first().data("tab-item-key");
            cExploreButtonSection = $(cExploreButtonElement).find(".c-explore-section");
            cExploreButtonTabs = $(cExploreButtonElement).find(".c-tabs");
            cExploreButtonMenuRight = $(cExploreButtonElement).find(".c-explore-section-menu-right");

            reset();

            $(cExploreButtonElement).on('click', function (e) {
                e.stopPropagation();
                cExploreButtonArrowElement.toggleClass("fa-chevron-down fa-chevron-up");
                reset();
                cExploreButtonDropdownElement.toggleClass('show');
                $(cExploreButtonElement).toggleClass("menu-opened");

                if ( cExploreButtonDropdownElement.hasClass("show") ){
                    if ( typeof window.avatarMenu === 'object' ){
                        window.avatarMenu.hide();
                    }
                    if ( typeof window.languageDropdownMenu === 'object' ){
                        window.languageDropdownMenu.hide();
                    }
                    if ( typeof window.searchBoxDesktop === 'object' ){
                        window.searchBoxDesktop.hide();
                    }
                }
            });

            // Close dropdown when clicking outside
            $(document).on("click", function () {
                cExploreButtonDropdownElement.removeClass("show");
                $(cExploreButtonElement).removeClass("menu-opened");
                cExploreButtonArrowElement.removeClass("fa-chevron-up");
                cExploreButtonArrowElement.addClass("fa-chevron-down");
            });

            cExploreButtonTabs.on("mouseenter", ".c-tabs-item", handleTabHover);

            // Prevent closing when clicking inside dropdown
            cExploreButtonDropdownElement.on("click", function (e) {
                e.stopPropagation();
            });
        }
    };
}();
